const get_started = {
    page_title: 'Başlangıca Başlayın',
    title: 'Başarınızı Desteklemek İçin Keşfedilecek Bir Şey',
    subtitle: "Logto'nun değerini hızla elde etmek için yapabileceğiniz birkaç şey",
    develop: {
        title: 'Geliştir: Uygulamanızı entegre etmek için 5 dakika ayırın',
        title_cloud: 'Geliştir: Uygulamanızı dakikalar içinde güvenli bir şekilde entegre edin',
        subtitle_cloud: "Veya uygulamanızı hazır SDK'larımız ve rehberlerimizle entegre etmek için 5 dakika ayırın.",
        try_mcp: 'MCP ile tek bir komutla entegrasyonu deneyin',
    },
    customize: {
        title: 'Özelleştir: Harika bir oturum açma deneyimi sunun',
        preview: {
            title: 'Yeni özelleştirdiğiniz oturum açma deneyiminin canlı önizlemesini kontrol edin',
            subtitle: 'Nasıl çalıştığını görmek için şimdi Logto oturum açma deneyimini deneyin',
        },
        connector: {
            title: 'Daha fazla bağdaştırıcı ekleyerek daha fazla sosyal oturum açma yöntemini destekleyin',
            subtitle: 'Şifresiz oturum açmayı deneyin ve müşterileriniz için güvenli ve sürtünmesiz bir deneyim sağlayın',
        },
        continue_customizing: 'Özelleştirmeye devam et',
        try_now: 'Şimdi deneyin',
        add_more: 'Daha fazla ekle',
    },
    secure: {
        title: 'Güvenli: Kaynaklarınızı koruyun',
    },
    manage: {
        title: 'Yönet: Ürününüz ve kullanıcılarınız için erişim denetimi tanımlayın',
        rbac: {
            title: 'Diverse kullanım durumları için ölçeklenebilir rol yetkilendirmesi ile kaynaklarınızı koruyun',
            subtitle: 'Kaynağınızı kontrol edin',
        },
        create_roles: 'Roller oluştur',
    },
    convert_to_production: {
        card_title: 'Yayınlamaya hazır mısınız? Üretim kurulumunuzu başlatmayı unutmayın!',
        title: 'Projenizi geliştirme modunda kalmasın',
        subtitle: 'Ücretsiz test için bir geliştirici kiracısı kullanıyorsunuz. Yayına geçmek için bir üretim kiracısı oluşturun veya dönüştürün. Özel bir şeye mi ihtiyacınız var? <a>Bizimle iletişime geçin</a>',
        convert_button: 'Üretim kiracısına dönüştür',
    },
    oss_cloud: {
        try: {
            title: 'Operasyon yükünü atlayın, Logto Cloud’u ücretsiz deneyin',
            badge: 'Önerilen',
            description: 'Bakım gerektirmeyen tamamen yönetilen bir Logto’ya sahip olun; ayrıca MCP ile hızlı entegrasyon, çoklu kiracı desteği, ekip iş birliği ve tüm premium özellikler de dahil. Kredi kartı gerektirmeden ücretsiz başlayın.',
            action: 'Logto Cloud’u keşfedin',
        },
        private_cloud: {
            title: 'Uyumluluk veya özel dağıtım mı gerekiyor?',
            card_title: 'Özel bulut',
            description: 'Tam veri izolasyonu, özel alan adı ve SLA garantileri ile özel bir Logto örneği edinin. Katı veri yerleşimi veya uyumluluk gereksinimleri olan şirketler için idealdir. Siz ürününüze odaklanırken altyapıyı biz yönetiriz.',
        },
        sidebar: {
            title: 'Barındırmaya değil, geliştirmeye odaklanın.',
            description: 'Kimlik doğrulama altyapısını sizin için Logto Cloud yönetsin.',
            action: "Logto Cloud'u deneyin",
        },
    },
    view_all: 'Hepsini görüntüle →',
};
export default Object.freeze(get_started);
